import React, { Component } from "react";
import { Row, Col } from "react-flexbox-grid";
import { Page, Fab } from "components/support";
import { Tabs, Tab } from "material-ui/Tabs";
import Typography from "material-ui-next/Typography";

import DataTable from "./data-table";
import Filter from "./filter";
import Revenues from "./revenues";
import Timeline from "./timeline";

import { colors, Icon } from "assets";

class SalesView extends Component {
  handleDownloadButton = format => this.props.presenter.onDownload(format);
  downloadButton = () => (
    <Fab
      backgroundColor={colors.button.secondary}
      tooltip="Download"
      icon="file_download"
      options={[
        {
          backgroundColor: colors.secondary.light,
          onClick: () => this.handleDownloadButton("csv"),
          iconComponent: (
            <Icon.CsvFile style={{ fill: colors.secondary.dark }} />
          ),
          tooltip: "CSV"
        }
        /*
        {
          backgroundColor: colors.primary.normal,
          onClick: () => this.handleDownloadButton('pdf'),
          icon: icons.svg.pdfFile,
          tooltip: 'PDF'
        },
        */
      ]}
    />
  );

  render() {
    const { presenter, viewModel } = this.props;
    const { loading, filter, revenues, content, pagination, order } = viewModel;
    return (
      <Page>
        <Typography type="display1" className="pb-sm">
          Histórico de Vendas
        </Typography>
        <Row>
          <Col xs={12} sm={8}>
            <Filter
              loading={loading.results}
              onChange={filter => this.props.presenter.onFilterChange(filter)}
              onFilter={filter => this.props.presenter.onFilterChange(filter)}
              dateFrom={filter.startDate}
              dateTo={filter.endDate}
              saleStatus={filter.saleStatus}
              documentNumber={filter.documentNumber}
              documentSerie={filter.documentSerie}
            />
          </Col>
          <Col xs={12} sm={4}>
            <Revenues loading={loading.revenues} value={revenues} />
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <Tabs
              inkBarStyle={{ backgroundColor: colors.accent.normal }}
              tabItemContainerStyle={{ backgroundColor: colors.primary.dark }}
            >
              <Tab label="Linha do Tempo">
                <Timeline
                  loading={loading.results}
                  content={content}
                  pagination={pagination}
                  handlePageChange={page => presenter.onPageChange(page)}
                  onDelete={sale => presenter.onRequestDelete(sale)}
                />
              </Tab>
              <Tab label="Tabela">
                <DataTable
                  loading={loading.results}
                  content={content}
                  pagination={pagination}
                  order={order}
                  handleDataTableChange={({ field, value }) =>
                    presenter.onOrderChange(field, value)
                  }
                  handlePageChange={page => presenter.onPageChange(page)}
                  onDelete={sale => presenter.onRequestDelete(sale)}
                />
              </Tab>
            </Tabs>

            {this.downloadButton()}
          </Col>
        </Row>
      </Page>
    );
  }
}

export default SalesView;



// WEBPACK FOOTER //
// ./src/components/app/history/sales/view.jsx